import Immutable from 'seamless-immutable'

const initialState = Immutable({})

const rootReducer = injectedReducers => {
    return (state = initialState, action) => {
        switch (action.type) {
            case 'TOGGLE_MODAL':
                return action.payload
                    ? state.set('MODAL', action.payload)
                    : state.without('MODAL')
            case 'TOGGLE_WIZARD':
                return state.set('showWizard', !state.showWizard)
            default:
                return injectedReducers ? injectedReducers(state, action) : state
        }
    }
}

export const createReducer = injectedReducers => rootReducer(injectedReducers)
